import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMessages } from 'store/chat/services/getMessages.service';
import { uniq } from 'lodash';
import { loadChatUsers } from './loadChatUsers';

export const fetchChatMessagesThunk = createAsyncThunk(
  'chat/fetchMessages',
  async ({ limit }, { getState, dispatch }) => {
    const state = getState();
    const { allMessagesFetched, thread, lastEvaluatedKey } = state.chatSlice;
    if (!allMessagesFetched) {
      const threadId = thread.isSubthread
        ? 'subthread'
        : thread.threadId || thread.id;
      const messages = await getMessages(
        threadId,
        lastEvaluatedKey,
        limit,
        thread.target,
        thread.type
      );
      const messageSenderIds = uniq(messages.map((msg) => msg.userId));
      // Filter out users that are already in users OR allUsers
      const newUserIds = messageSenderIds.filter(
        (id) => !state.chatSlice.users[id] && !state.chatSlice.allUsers[id]
      );
      if (newUserIds.length > 0) {
        dispatch(
          loadChatUsers({ userIds: newUserIds, addToCurrentUsers: true })
        );
      }
      return { messages: messages };
    }
    return { messages: [] };
  }
);
